import React from 'react'
import { motion } from "framer-motion";


const price = () => {

  return (
    <>

<section className="py-5 bg-light d-flex align-items-center ">
  <div className="container px-4">
    <div className="mx-auto text-center mb-5" style={{ maxWidth: "768px" }}>
      <motion.span
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="d-inline-block px-3 py-1 rounded-pill bg-primary text-white fw-medium mb-3"
      >
        Our Process
      </motion.span>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="h2 fw-bold mb-4"
      >
        How We Work
      </motion.h2>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.1 }}
        className="text-muted fs-5"
      >
        Our structured approach ensures we deliver high-quality solutions that meet your specific needs.
      </motion.p>
    </div>

    <div className="row g-4 d-flex flex-row flex-wrap">
      <ProcessStep
        number="01"
        title="Discovery"
        description="We start by understanding your business, goals, and requirements through in-depth discussions."
        icon="fas fa-search"
        color="bg-primary"
        delay={0}
      />
      <ProcessStep
        number="02"
        title="Planning"
        description="Our team creates a detailed project plan, including timelines, milestones, and deliverables."
        icon="fas fa-clipboard-list"
        color="bg-success"
        delay={0.1}
      />
      <ProcessStep
        number="03"
        title="Development"
        description="We build your solution using agile methodologies, with regular updates and feedback sessions."
        icon="fas fa-code"
        color="bg-info"
        delay={0.2}
      />
      <ProcessStep
        number="04"
        title="Delivery"
        description="After thorough testing, we deploy your solution and provide ongoing support and maintenance."
        icon="fas fa-rocket"
        color="bg-warning"
        delay={0.3}
      />
    </div>
  </div>
</section>


        <section className="py-5 bg-light">
      <div className="container">
        <div className="mx-auto text-center mb-5" style={{ maxWidth: "768px" }}>
          <motion.span 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="d-inline-block px-3 py-1 rounded-pill bg-primary text-white fw-medium mb-3"
          >
            FAQ
          </motion.span>
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="h2 fw-bold mb-3"
          >
            Frequently Asked Questions
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-secondary fs-5"
          >
            Find answers to common questions about our services and process.
          </motion.p>
        </div>

        <div className="mx-auto" style={{ maxWidth: "768px" }}>
          <FaqItem 
            question="How long does a typical project take?"
            answer="Project timelines vary depending on complexity. A simple website might take 4-6 days, while complex applications can take 3-6 weeks. We provide detailed timelines during the planning phase."
            delay={0}
          />
          <FaqItem 
            question="What technologies do you use?"
            answer="We use modern technologies like React, Angular, Vue.js, Node.js, Flutter, React Native, and more. Our technology choices are based on your specific requirements and what best suits your project."
            delay={0.1}
          />
          <FaqItem 
            question="Do you provide ongoing maintenance and support?"
            answer="Yes, we offer various support and maintenance to ensure your application continues to run smoothly after launch. This includes bug fixes, security updates, and feature enhancements."
            delay={0.2}
          />
          <FaqItem 
            question="How much does a project cost?"
            answer="Project costs vary widely based on requirements. We provide transparent quotes after understanding your needs. We can work with fixed-price contracts or time-and-materials arrangements depending on your preference."
            delay={0.3}
          />
          <FaqItem 
            question="Do you work with clients internationally?"
            answer="Yes, we work with clients worldwide. We have established communication processes for different time zones and use collaboration tools to ensure smooth project execution regardless of location."
            delay={0.4}
          />
        </div>
      </div>
    </section>
    </>
  )
}

const ProcessStep = ({ number, title, description, icon, color, delay }) => {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay }}
        className="d-flex flex-column align-items-center text-center p-3"
      >
        {/* Icon Container */}
        <div className={`d-flex align-items-center justify-content-center ${color} rounded-circle text-white mb-3`} 
             style={{ width: '64px', height: '64px' }}>
          <i className={`${icon} fs-4`}></i>
        </div>
  
        {/* Content Card */}
        <div className="bg-white rounded p-4 shadow-sm w-100">
          <span className="h1 fw-bold text-secondary">{number}</span>
          <h3 className="h5 fw-bold mb-2">{title}</h3>
          <p className="text-muted">{description}</p>
        </div>
      </motion.div>
    );
  };
  


const FaqItem = ({ question, answer, delay }) => {
    return (
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay }}
        className="border-bottom py-4"
      >
        <h3 className="h5 fw-bold mb-2">{question}</h3>
        <p className="text-secondary">{answer}</p>
      </motion.div>
    );
  };


export default price